import { formatInVenueZone } from 'utils/shared/time/formatInVenueZone';
import classNames from 'styles/utils/classNames';

interface Props {
  /** ISO start date of the activity. */
  date: string;
  /** IANA zone to render the date in (venue's); browser zone when omitted. */
  timezone?: string;
  className?: string;
}

/**
 * A compact weekday-over-day rail: `DateColumn`'s mobile face, and the label
 * inside the request form's day tiles.
 */
export default function DateRail({ date, timezone, className }: Props) {
  const parsed = new Date(date);
  const fmt = (pattern: string) => formatInVenueZone(parsed, pattern, timezone);

  return (
    <div
      className={classNames(
        'flex w-10 shrink-0 flex-col items-center whitespace-nowrap',
        className,
      )}
    >
      <span className="typography-product-body-highlight uppercase text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
        {fmt('EEE')}
      </span>
      <span className="typography-informative-subheading-highlight text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
        {fmt('d')}
      </span>
    </div>
  );
}
